import React from 'react';

import { FrequentlyAskedQuestion as BaseFaq } from '@rover/components/src/FrequentlyAskedQuestions';
import dataLayer from '@rover/globals/dataLayer';

type FrequentlyAskedQuestionProps = Omit<React.ComponentProps<typeof BaseFaq>, 'onToggle'>;

function onFaqOpen(isOpen: boolean): void {
  if (isOpen) {
    dataLayer?.push({
      event: 'city-service-landing-faq-expand-click',
    });
  }
}

const FrequentlyAskedQuestion: React.FC<FrequentlyAskedQuestionProps> = (props) => {
  return <BaseFaq {...props} onToggle={onFaqOpen} />;
};

export default FrequentlyAskedQuestion;
